import { useContext, useCallback } from 'react';

import { ImportStateContext } from '../components/ImportStateContextProvider.tsx';
import { getProcessErrorType } from '../utils/getProcessErrorType.ts';

import { ErrorRoles } from './useUploadReducer.ts';

export const useHandleBulkProcessingErrors = (): ((title: any, errors: any) => void) => {
	const {
		docActions: { uploadDocFailure },
	} = useContext(ImportStateContext);

	return useCallback(
		(title: any, errors: any) => {
			return uploadDocFailure(title, {
				type: getProcessErrorType(errors),
				role: ErrorRoles.WARNING,
			});
		},
		[uploadDocFailure],
	);
};
